"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const antd_1 = require("antd");
const Icon_1 = __importDefault(require("../Icon"));
const { Dragger } = antd_1.Upload;
const { Paragraph } = antd_1.Typography;
const FileUpload = ({ multiple = false, maxCount = 1, loading, loadingText, name = '', fileList = [], setData, }) => {
    const props = {
        multiple,
        maxCount,
        beforeUpload: () => false,
        onChange: (info) => setData(info.file, name),
    };
    // pass defaultFileList if you want the component to be uncontrolled
    return ((0, jsx_runtime_1.jsx)(antd_1.Spin, Object.assign({ spinning: loading, tip: loadingText }, { children: (0, jsx_runtime_1.jsxs)(Dragger
        // eslint-disable-next-line react/jsx-props-no-spreading
        , Object.assign({}, (fileList.length > 0 ? Object.assign(Object.assign({}, props), { fileList }) : Object.assign(Object.assign({}, props), { defaultFileList: [] })), { children: [(0, jsx_runtime_1.jsx)(Icon_1.default, { iconName: 'inbox', iconStyle: 'baseline', variant: 'primary', size: 'L' }), (0, jsx_runtime_1.jsx)(Paragraph, Object.assign({ style: { margin: 0 } }, { children: "Click or drag file to this area to upload" }))] })) })));
};
exports.default = FileUpload;
